export const DROPDOWN_EXTRA_SPACE_IN_PX: number = 130;

export const TAG_CLOUD_DEFAULT_FONT_SIZE: number = 20;
